import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { BANK_PATH } from '../../../../config/paths';
import BankDeleteButton from './BankDeleteButton';

const BankToolbar = ({ bankId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${BANK_PATH}/${bankId}/edit`} />{' '}
      <BankDeleteButton bankId={bankId} />
    </div>
  </ButtonToolbar>
);

BankToolbar.propTypes = {
  bankId: PropTypes.number.isRequired,
};

export default BankToolbar;
